import React from 'react';
import { ThemeProvider as ThemeProvider$1, useTheme as useTheme$1 } from '@emotion/react';
import { t as theme } from './theme-c93653c9.js';

const ThemeProvider = ({ theme: theme$1 = theme, children, }) => {
    return React.createElement(ThemeProvider$1, { theme: theme$1 }, children);
};
function useTheme() {
    const theme = useTheme$1();
    return theme;
}

export { ThemeProvider as T, useTheme as u };
